import { get } from "lodash";
import React from "react";
import { formatInvoiceTag } from "../../pages/bookings/util";
import { Booking } from "../../types";
import { formatDisplayDateTime } from "../../utils/date";
import { BookingIdField } from "../fields";
import { FieldProps } from "../fields/types";
import MyCard from "./MyCard";

const BookingCard: React.FC<FieldProps> = (props) => {
  const { record, source } = props;
  const booking: Booking = source === "id" ? record : get(record, source);

  if (!booking) return <></>;

  console.log(booking.date)
  console.log(formatDisplayDateTime(booking.date));

  return (
    <MyCard
      title="Booking"
      status={<BookingIdField record={booking} />}
      content={[
        {
          label: "date",
          value: formatDisplayDateTime(booking.date),
        },
        {
          label: "Venue",
          value: `${booking.hospital.name ?? ""} (${
            booking.hospital_room.name
          })`,
        },
        { label: "Surgeon", value: booking.surgeon?.full_name ?? "" },
        { label: "Consultant", value: booking.consultant?.full_name ?? "" },
        {
          label:
            process.env.REACT_APP_COMPANY_CODE === "STMY"
              ? "Order Type"
              : "Procedure",
          value: booking.procedure?.name ?? "",
        },
        {
          label: "Invoice Number",
          value: booking.invoice_number || "-",
        },
        {
          label: "Invoice Tag",
          value: formatInvoiceTag(booking),
        },
      ]}
    />
  );
};

BookingCard.defaultProps = {
  label: "Booking",
  addLabel: true,
};

export default BookingCard;
